import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card"]

  static values = {
    empty: String
  }

  declare readonly cardTarget: HTMLElement
  declare readonly emptyValue: string

  show(event: MouseEvent) {
    const target = event.target as HTMLElement
    // Grid view uses .grid-item, timeline view uses .timeline-item
    const cell = target.closest(".grid-item, .timeline-item") as HTMLElement
    if (!cell) return

    // title attribute holds the date string set in the Go template (e.g. "15 Mar")
    const date = cell.getAttribute("title")
    if (!date) return

    // data-moods holds the pre-translated mood string (e.g. "Happy" or "Happy & Peaceful")
    const moods = cell.dataset.moods || ""
    const status = moods || this.emptyValue || "Empty"

    this.cardTarget.innerHTML = `
      <span class="tooltip-date">${date}</span>
      <span class="tooltip-status">${status}</span>
    `

    this.cardTarget.classList.add("visible")
    this.cardTarget.setAttribute("aria-hidden", "false")

    this.move(event)
  }

  move(event: MouseEvent) {
    if (!this.cardTarget.classList.contains("visible")) return

    const offset = 14
    this.cardTarget.style.left = `${event.clientX + offset}px`
    this.cardTarget.style.top = `${event.clientY + offset}px`
  }

  hide() {
    this.cardTarget.classList.remove("visible")
    this.cardTarget.setAttribute("aria-hidden", "true")
  }
}
